import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaBluesky } from "react-icons/fa6";

export const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer__icon">
				<a
					href="https://www.linkedin.com/in/alisa-moldavanova-7197442/"
					className="footer__icon-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaLinkedin />
				</a>
				<a
					href="https://www.instagram.com/ladycosm/?hl=en"
					className="footer__icon-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaInstagram />
				</a>
				<a
					href="https://www.facebook.com/alisa.moldavanova"
					className="footer__icon-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaFacebookSquare />
				</a>

				<a
					href="https://x.com/Sustain_Scholar"
					className="contacts__social-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaXTwitter />
				</a>
				<a
					href="https://bsky.app/profile/sustainscholar.bsky.social"
					className="contacts__social-link"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaBluesky />
				</a>
			</div>
			<div className="jane">
				<p>
					© 2025 Designed by
					<a
						href="https://jane.work/"
						target="_blank"
						rel="noopener noreferrer"
						className="jane__link"
					>
						<img
							className="jane__logo"
							src="/jane_logo.png"
							alt=""
						/>
					</a>
					. All Rights Reserved.
				</p>
			</div>
		</footer>
	);
};
